// extracted by mini-css-extract-plugin
export var circle = "_2o-2";
export var icon = "_2o-a";
export var iconHighlight = "_2o-0";
export var lg = "_2o-8";
export var md = "_2o-7";
export var outline = "_2o-4";
export var sm = "_2o-6";
export var square = "_2o-1";
export var xl = "_2o-9";
export var xs = "_2o-5";
export var xxs = "_2o-3";